'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useParams, useRouter } from 'next/navigation';

function ChannelHomeTabsContainer() {
  const params = useParams<{ id: string }>();
  const channelId = params?.id ? decodeURIComponent(params.id) : '';
  const router = useRouter();

  return (
    <PageTabsContainer className='mb-10 min-w-[1360px]' contentClassName='w-[1360px] px-10 mx-auto'>
      <PageTab
        includedURLPath='/home/member'
        onClick={() => router.push(`/channel/${channelId}/home/member`)}
        isMiddleLine
        className='ml-0'
      >
        회원 선물 하트
      </PageTab>
      <PageTab
        includedURLPath='/home/event'
        onClick={() => router.push(`/channel/${channelId}/home/event`)}
        isMiddleLine
      >
        이벤트 하트
      </PageTab>
      <PageTab includedURLPath='/home/hold' onClick={() => router.push(`/channel/${channelId}/home/hold`)} isMiddleLine>
        보류 하트
      </PageTab>
    </PageTabsContainer>
  );
}

export default ChannelHomeTabsContainer;
